import InputGroup from "react-bootstrap/InputGroup";
import { ProjectRole, userDocumentSchema } from "../../types/firestore";
import { useMemo } from "react";
import { doc, getFirestore } from "firebase/firestore";
import { getFirestoreZodConverter } from "../../modules/firestoreZodConverter";
import { useDocumentData } from "react-firebase-hooks/firestore";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import EditMemberRole from "./editMemberRole";
import RemoveMember from "./removeMember";
import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth } from "firebase/auth";
import roleNames from "../../modules/roleNames";

const auth = getAuth();
const firestore = getFirestore();

export interface MemberProps {
	projectId: string;
	memberId: string;
	memberRole: ProjectRole;
	isCurrentUserAdmin: boolean;
}

export default function Member(props: MemberProps) {
	const memberDocumentRef = useMemo(
		() =>
			doc(firestore, "Users", props.memberId).withConverter(
				getFirestoreZodConverter(userDocumentSchema),
			),
		[props.memberId],
	);

	const [user] = useAuthState(auth);

	const [memberDocument] = useDocumentData(memberDocumentRef);

	if (!user) return <div></div>;

	return (
		<InputGroup className="mb-2">
			<InputGroup.Text>
				{memberDocument?.FirstName} {memberDocument?.LastName}
			</InputGroup.Text>
			{props.isCurrentUserAdmin && (
				<DropdownButton
					disabled={props.memberRole === ProjectRole.Owner || user.uid === props.memberId}
					variant="outline-secondary"
					title={roleNames[props.memberRole]}>
					{[ProjectRole.Admin, ProjectRole.Driver].map((role) => (
						<EditMemberRole
							key={role}
							memberId={props.memberId}
							memberRole={props.memberRole}
							newMemberRole={role}
							projectId={props.projectId}
						/>
					))}

					<Dropdown.Divider />

					<RemoveMember memberId={props.memberId} projectId={props.projectId} />
				</DropdownButton>
			)}
		</InputGroup>
	);
}
